export default __webpack_public_path__ + "static/media/emac.2fb7c59c.png";